import * as React from 'react';
import * as styles from './PhoneNumber.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { Link, ILinkStyles } from '@fluentui/react/lib/Link';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { phoneAriaText } from './PhoneNumber.locstring.json';

const phoneNumberStyles: ILinkStyles = {
    root: {
        // phone numbers are always read LTR, so define the direction so numbers don't get misordered
        // https://docs.microsoft.com/en-us/dynamics365/fin-ops-core/dev-itpro/user-interface/bidirectional-support
        direction: 'ltr',
    },
};

export default observer(function PhoneNumber({
    phoneNumberText,
    containerClassName,
    iconClassName,
    phoneNumberTextClassName,
}: {
    phoneNumberText: string;
    containerClassName?: string;
    iconClassName?: string;
    phoneNumberTextClassName?: string;
}) {
    return (
        <div className={classNames(styles.phoneNumberContainer, containerClassName ?? '')}>
            <Icon iconName={ControlIcons.Phone} className={iconClassName} />
            <Link
                href={'tel:' + phoneNumberText}
                aria-label={loc(phoneAriaText, phoneNumberText)}
                target="_blank"
                styles={phoneNumberStyles}
                className={phoneNumberTextClassName}>
                {phoneNumberText}
            </Link>
        </div>
    );
});
